document.addEventListener("DOMContentLoaded", () => {
  if (!$('html').hasClass('page-welcome')) return;

  const slideDelay = 5000
  const animationDuration = 300
  let curSlide = 1

  function firstSlide() {
    setTimeout(() => {
      const video = getWelcomeVideo()
      video.play()
      video.addEventListener("ended", onVideoEnded)
      nextSlide()
    }, slideDelay)
  }
  firstSlide()

  function onVideoEnded() {
    nextSlide()
    thirdSlide()
    this.removeEventListener('ended', onVideoEnded);
  }

  function thirdSlide() {
    setTimeout(() => {
      $('.welcome-slides').fadeTo(animationDuration, 0, function () {$(this).hide()})
    }, slideDelay)
  }

  $('.welcome-slides .skip').click(() => {
    const video = getWelcomeVideo()
    video.pause()
    nextSlide()
    thirdSlide()
  })

  function nextSlide() {
    $(`.welcome-slides .slide${curSlide}`).fadeTo(animationDuration, 0, function () {$(this).hide()})
    curSlide += 1
    $(`.welcome-slides .slide${curSlide}`).fadeTo(animationDuration, 1).css('z-index', curSlide);
  }

  function getWelcomeVideo() {
    return $('#common-video-slide-2 video').get(0)
  }
});
